import { render, staticRenderFns } from "./setSecretQuestionPage.vue?vue&type=template&id=5a77bdc2&scoped=true"
import script from "./setSecretQuestionPage.vue?vue&type=script&lang=js"
export * from "./setSecretQuestionPage.vue?vue&type=script&lang=js"
import style0 from "./setSecretQuestionPage.vue?vue&type=style&index=0&id=5a77bdc2&prod&lang=scss"
import style1 from "./setSecretQuestionPage.vue?vue&type=style&index=1&id=5a77bdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77bdc2",
  null
  
)

export default component.exports